import template from './garage-type.jade';
import { types, garageTypes, boxTypes } from '../../../enums/garage-type';
import validation from '../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.garageType', []).directive('cianAfAboutObjectGarageType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService, store) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.types = types;
    this.garageTypes = garageTypes;
    this.boxTypes = boxTypes;

    this.validation = validation(this.form, 'garage.type', {
      required: 'Обязательное поле',
    });

    this.handleChange = () => {
      const state = store.getState();
      const category = selectAnalyticsOfferStatus(state);

      trackRequiredFieldFill(category, 'building_type');
    };
  },
  controllerAs: 'garageType',
  template,
})).name;
